/* eslint-disable global-require */
import React from 'react';
import {
  Button, Checkbox, Form, Input
} from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/InfoView';
import PropTypes from 'prop-types';

const FormItem = Form.Item;

class SignUp extends React.Component {
  componentDidUpdate() {
    if (this.props.token !== null) {
      this.props.history.push('/');
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // this.props.userSignUp(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                <img alt="Neature" src="https://via.placeholder.com/272x395" />
              </div>
              <div className="gx-app-logo-wid">
                <h1><IntlMessages id="app.userAuth.signUp" /></h1>
                <p><IntlMessages id="app.userAuth.bySigning" /></p>
                <p><IntlMessages id="app.userAuth.getAccount" /></p>
              </div>
              <div className="gx-app-logo">
                <img alt="example" src={require('assets/images/logo.png')} />
              </div>
            </div>

            <div className="gx-app-login-content">
              <Form className="gx-signup-form gx-form-row0" onSubmit={this.handleSubmit}>
                <FormItem>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: 'Please input your username!' }]
                  })(
                    <Input placeholder="Name" />
                  )}
                </FormItem>

                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [{
                      required: true, type: 'email', message: 'The input is not valid E-mail!'
                    }]
                  })(
                    <Input placeholder="Email" />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please input your Password!' }]
                  })(
                    <Input placeholder="Password" type="password" />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: true
                  })(
                    <Checkbox><IntlMessages id="appModule.iAccept" /></Checkbox>
                  )}
                  <span className="gx-link gx-signup-form-forgot"><IntlMessages
                    id="appModule.termAndCondition"
                  />
                  </span>
                </FormItem>
                <FormItem>
                  <Button className="gx-mb-0" htmlType="submit" type="primary">
                    <IntlMessages id="app.userAuth.signUp" />
                  </Button>
                  <span><IntlMessages id="app.userAuth.or" /></span>
                  <Link to="/dang-nhap"><IntlMessages
                    id="app.userAuth.signIn"
                  />
                  </Link>
                </FormItem>
              </Form>
            </div>
            <InfoView />
          </div>
        </div>
      </div>
    );
  }
}

SignUp.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  token: PropTypes.string.isRequired
};

const WrappedSignUpForm = Form.create()(SignUp);

const mapStateToProps = ({ auth }) => {
  const { token } = auth;
  return { token };
};

export default connect(mapStateToProps, {})(WrappedSignUpForm);
